import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import MessagePage from '../../views/MessagePage/';
const GLOBAL = require('../../Globals');

class SMSSetup extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			smsapi: '',
			apiurl: '',
			sender: '',
			route: '',
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onattMsgChange = this.onattMsgChange.bind(this);
	}

	onattMsgChange(e){
		
		if(e.target.checked){
			
			this.state.isattmsg = 1;
			this.setState({isattmsg  :1});
		}
		else {
			
			this.state.isattmsg = 0;
			this.setState({isattmsg  :0});
		}
		
	}

	/** set value **/
	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	onSubmit(e) {
		e.preventDefault();

		this.state.smscount = $("#smscount").val();
		$("#showLoader").show();
		PostData('message/addsmssetup', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.setState({
					_message: 'Setup Updated Successfully!..',
					alertClass: 'alert alert-success',
				});
				this.getdata();
			}
			else {

				this.setState({
					_message: 'Invalid Key',
					alertClass: 'alert alert-danger'
				});
			}
		});

		// }

	}

	/** this function will be call when page loading **/
	componentWillMount() {

		this.getdata();
	}

	getdata() {
		$("#showLoader").show();
		GetData('message/getsmssetup').then((result) => {
			$("#showLoader").hide();
			let res = result;
			if (res) {

				this.setState({
					smsapi: res[0]['smsapi'],
					apiurl: res[0]['apiurl'],
					sender: res[0]['senderid'],
					route: res[0]['route'],
					isattmsg : res[0]['isattmsg']
				});

			}

		});
	}

	render() {

		/** set route select box **/
		this.sroute = [
			{ value: '', name: 'Select' },
			{ value: '4', name: 'Transactional' },
			{ value: '0', name: 'Promotional' }
		];

		return (
			<div>
				<MessagePage />
					<div className="animated fadeIn">
						<div className={this.state.alertClass}>
							{this.state._message}
						</div>
						<form action="" method="post" role="form" id="smssetup" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<input type="hidden" id="smscount" />
						<input type="hidden" name="isattmsg" value={this.state.isattmsg} />
						<Row>
							<Col md="12">
								<Card>
									<CardHeader>
										<strong>SMS Setup</strong>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="1">
												<FormGroup>
													<Label htmlFor="name">SMS API</Label>
												</FormGroup>
											</Col>
											<Col md="4">
												<FormGroup>
													<Input type="text" name="smsapi" onChange={this.onChange} value={this.state.smsapi} />
												</FormGroup>
											</Col>
											<Col md="1">
												<FormGroup>
													<Label htmlFor="name">API URL</Label>
												</FormGroup>
											</Col>
											<Col md="5">
												<FormGroup>
													<Input type="text" name="apiurl" onChange={this.onChange} value={this.state.apiurl} />
												</FormGroup>
											</Col>
											<Col md="1"></Col>
											<Col md="1">
												<FormGroup>
													<Label htmlFor="name">Sender Id</Label>
												</FormGroup>
											</Col>
											<Col md="4">
												<FormGroup>
													<Input type="text" name="sender" onChange={this.onChange} value={this.state.sender} />
												</FormGroup>
											</Col>
											<Col md="1">
												<FormGroup>
													<Label htmlFor="name">Route</Label>
												</FormGroup>
											</Col>
											<Col md="5">
												<FormGroup>
													<select name="route" className="form-control" onChange={this.onChange} value={this.state.route}>
														{this.sroute.map((e, key) => {
															return <option key={key} value={e.value}>{e.name}</option>;
														})}
													</select>
												</FormGroup>
											</Col>
										</Row>
									</CardBody>
									<CardFooter>
										<Button type="submit" size="sm" color="primary" className="btn-right" ><i className="fa fa-dot-circle-o"></i> Save</Button>
									</CardFooter>
								</Card>
							</Col>
						</Row>
						<Row>
							<Col md="12">
								<Card>
									<CardHeader>
										<strong>SMS Permissions</strong>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="12">
											&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
											{/*<Label className="form-check-label" check htmlFor="inline-checkbox1" > Group SMS</Label>&nbsp;&nbsp;
											<Label className="switch switch-text switch-pill switch-primary-outline-alt">
												<Input type="checkbox" className="switch-input" id="isgrpmsg" name="isgrpmsg" onClick={this.onGrpMsgChange} defaultChecked={this.state.isgrp} />
												<span className="switch-label" data-on="On" data-off="Off"></span>
												<span className="switch-handle"></span>
													</Label>
											&nbsp;&nbsp;&nbsp;
										
											<Label className="form-check-label" check htmlFor="inline-checkbox1" > Birthday SMS</Label>&nbsp;&nbsp;
											<Label className="switch switch-text switch-pill switch-primary-outline-alt">
												<Input type="checkbox" className="switch-input" id="iswishmsg" name="iswishmsg" onClick={this.onwishMsgChange} defaultChecked={this.state.iswish} />
												<span className="switch-label" data-on="On" data-off="Off"></span>
												<span className="switch-handle"></span>
											</Label>
											&nbsp;&nbsp;&nbsp;
											
											<Label className="form-check-label" check htmlFor="inline-checkbox1" > Homework SMS</Label>&nbsp;&nbsp;
											<Label className="switch switch-text switch-pill switch-primary-outline-alt">
												<Input type="checkbox" className="switch-input" id="ishwmsg" name="ishwmsg" onClick={this.onhwMsgChange} defaultChecked={this.state.ishw} />
												<span className="switch-label" data-on="On" data-off="Off"></span>
												<span className="switch-handle"></span>
											</Label>
											&nbsp;&nbsp;&nbsp;
											
											<Label className="form-check-label" check htmlFor="inline-checkbox1" > From App SMS</Label>&nbsp;&nbsp;
											<Label className="switch switch-text switch-pill switch-primary-outline-alt">
												<Input type="checkbox" className="switch-input" id="isappmsg" name="isappmsg" onClick={this.onappMsgChange} defaultChecked={this.state.isapp} />
												<span className="switch-label" data-on="On" data-off="Off"></span>
												<span className="switch-handle"></span>
											</Label>
											&nbsp;&nbsp;&nbsp;
											
											<Label className="form-check-label" check htmlFor="inline-checkbox1" > Admission SMS</Label>&nbsp;&nbsp;
											<Label className="switch switch-text switch-pill switch-primary-outline-alt">
												<Input type="checkbox" className="switch-input" id="isadmsg" name="isadmsg" onClick={this.onadMsgChange} defaultChecked={this.state.isad} />
												<span className="switch-label" data-on="On" data-off="Off"></span>
												<span className="switch-handle"></span>
											</Label>
											&nbsp;&nbsp;&nbsp;*/}
											
											<Label className="form-check-label" check htmlFor="inline-checkbox1" > Attendance SMS</Label>&nbsp;&nbsp;
											<Label className="switch switch-text switch-pill switch-primary-outline-alt">
												<Input type="checkbox" className="switch-input" id="isattmsg" name="isattmsg" onClick={this.onattMsgChange} checked={this.state.isattmsg == 1 ? true : false} />
												<span className="switch-label" data-on="On" data-off="Off"></span>
												<span className="switch-handle"></span>
											</Label>
											&nbsp;&nbsp;&nbsp;
											
											</Col>
										</Row>
									</CardBody>
									<CardFooter>
										<Button type="submit" size="sm" color="primary" className="btn-right" ><i className="fa fa-dot-circle-o"></i> Save</Button>
									</CardFooter>
								</Card>
							</Col>
						</Row>
					</form>
				</div>
			</div>
		)
	}
}

export default SMSSetup;


// WEBPACK FOOTER //
// ./src/message/SMSSetup/SMSSetup.js